import * as consts from "../common/constants";


export const validityPeriodToDisplay = (validityPeriod) => {
    switch (validityPeriod) {
        case consts.VALIDITY_PERIOD.VALIDITY_PERIOD_1D:
            return "1 day";
        case consts.VALIDITY_PERIOD.VALIDITY_PERIOD_2D:
            return "2 days";
        case consts.VALIDITY_PERIOD.VALIDITY_PERIOD_1W:
            return "1 week";
        case consts.VALIDITY_PERIOD.VALIDITY_PERIOD_1M:
            return "1 month";
        case consts.VALIDITY_PERIOD.VALIDITY_PERIOD_3M:
            return "3 months";
        case consts.VALIDITY_PERIOD.VALIDITY_PERIOD_6M:
            return "6 months";
        case consts.VALIDITY_PERIOD.VALIDITY_PERIOD_1YPLUS:
            return "1+ years";
        default:
            return validityPeriod;
    }
};

export const communicatedViaToDisplay = (communicatedVia) => {
    switch (communicatedVia) {
        case consts.COMMUNICATED_VIA.EMAIL:
            return "Email";
        case consts.COMMUNICATED_VIA.IM:
            return "Instant message";
        case consts.COMMUNICATED_VIA.IN_PERSON:
            return "In person";
        case consts.COMMUNICATED_VIA.MESSAGE:
            return "Message";
        case consts.COMMUNICATED_VIA.PHONE:
            return "Phone call";
        case consts.COMMUNICATED_VIA.TV:
            return "Broadcast";
        case consts.COMMUNICATED_VIA.TRADE_IDEA:
            return "Trade Idea";
        default:
            return communicatedVia;
    }
};

export const valueOrEmDash = (value) => (
    (value === null || value === undefined) ? "—" : value
);


/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/displayUtils.js
 **/